import { RefObject, useCallback, useEffect, useState } from 'react';
import { useSensor } from './use-sensor';

export const useWidthObserver = <T extends HTMLElement>(): {
  width: number;
  ref: RefObject<T>;
  forceUpdate: () => void;
} => {

  const ref = useSensor<T>(() => setWidth(ref.current?.offsetWidth));

  // initiate and keep track of width
  const [width, setWidth] = useState(ref.current?.offsetWidth);

  useEffect(() => {

    setWidth(ref.current?.offsetWidth);
  }, [ref.current]);

  // forceUpdate callback to immediately update width state
  const forceUpdate = useCallback(() => {
    setWidth(ref.current?.offsetWidth);
  }, []);

  return { width, ref, forceUpdate };
};
